import LxcError from "~/core/models/LxcError.class";
import dtwinService from "~/modules/dtwin/services/dtwin.service";

export function useDeleteDtwin({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function deleteDtwin(dtwinUid: string) {
    isLoading.value = true;
    error.value = undefined;

    const response = await dtwinService.deleteOrganizationDtwin(
      organizationCode,
      dtwinUid,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    deleteDtwin,
  };
}
